import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/category/foam-roofing")({
  beforeLoad: () => { throw redirect({ to: "/blog/category/$category", params: { category: "foam-roofing" }, statusCode: 301 }); },
});
